import * as React from 'react'
import clsx from 'clsx'

const styles = {
  base: [
    'relative w-full rounded-lg p-4 text-base/6 sm:text-sm/6',
    'flex gap-3 items-start',
  ],
  colors: {
    info: [
      'bg-blue-500/15 text-blue-700',
      '[--banner-icon:theme(colors.blue.500)]',
    ],
    warning: [
      'bg-amber-500/15 text-amber-700',
      '[--banner-icon:theme(colors.amber.500)]',
    ],
    success: [
      'bg-green-500/15 text-green-700',
      '[--banner-icon:theme(colors.green.500)]',
    ],
    danger: [
      'bg-red-500/15 text-red-700',
      '[--banner-icon:theme(colors.red.500)]',
    ],
  },
}

const icons = {
  info: (
    <svg className="h-5 w-5 flex-none fill-[--banner-icon]" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-9v4a1 1 0 11-2 0V9a1 1 0 112 0zm-1-4a1 1 0 100 2 1 1 0 000-2z" clipRule="evenodd" />
    </svg>
  ),
  warning: (
    <svg className="h-5 w-5 flex-none fill-[--banner-icon]" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
    </svg>
  ),
  success: (
    <svg className="h-5 w-5 flex-none fill-[--banner-icon]" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
    </svg>
  ),
  danger: (
    <svg className="h-5 w-5 flex-none fill-[--banner-icon]" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clipRule="evenodd" />
    </svg>
  ),
}

type BannerLevel = keyof typeof styles.colors

interface BannerProps extends React.HTMLAttributes<HTMLDivElement> {
  level?: BannerLevel
  title?: string
  children: React.ReactNode
}

export function Banner({ 
  level = 'info',
  title,
  className,
  children,
  ...props 
}: BannerProps) {
  return (
    <div
      role="alert"
      className={clsx(className, styles.base, styles.colors[level])}
      {...props}
    >
      {icons[level]}
      <div className="w-full">
        {title && (
          <div className="mb-1 font-medium">
            {title}
          </div>
        )}
        <div className="text-[--banner-text]">
          {children}
        </div>
      </div>
    </div>
  )
} 